import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormMode } from 'src/app/shared/base/FormMode';
import { CitesPageBaseComponent } from '../shared/CitesPageBaseComponent';
import { CitesReleaseSpeciesWorkflowService } from './cites-release-species-workflow.service';
import { serviceComponentSharedProviders } from 'src/app/core/services/state-services/state-management/injection/service-component-shared-providers';

@Component({
  selector: 'app-cites-release-species',
  templateUrl: './cites-release-species.component.html',
  styleUrls: ['./../../import-release-shared/import-release.module.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: 'WorkflowService',
      useClass: CitesReleaseSpeciesWorkflowService,
    },
    ...serviceComponentSharedProviders,
  ],
})
export class CitesReleaseSpeciesComponent extends CitesPageBaseComponent {
  get formMode(): FormMode {
    return FormMode.EDITING;
  }

  constructor(
    @Inject('WorkflowService')
    workflowService: CitesReleaseSpeciesWorkflowService,
    route: ActivatedRoute,
    translate: TranslateService
  ) {
    super(workflowService, route, translate);
  }

  ngOnInit(): void {
    this.subscribeToSizeSettings();
  }
}
